import React, { useState } from "react";
import cx from "classnames";

import {
  useLoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
  StandaloneSearchBox,
} from "@react-google-maps/api";

const mapOptions = {
  panControl: false,
  zoomControl: true,
  panControl: false,
  maxZoom: 18,
  scrollwheel: false,
  mapTypeControl: false,
  overviewMapControl: false,
  fullscreenControl: false,
  overviewMapControlOptions: {
    opened: false,
  },
  streetViewControl: false,
  scaleControl: false,
};

const libraries = ["places"];

const containerStyle = {
  width: "100%",
  height: "600px",
};

const LocatorMap = ({ displayLocation = false }) => {
  const [mapRef, setMapRef] = useState(null);
  const [markersInView, setMarkersInView] = useState(true);

  const [markerMap, setMarkerMap] = useState({}); // eslint-disable-line no-unused-vars
  const [center, setCenter] = useState({ lat: 37.7749, lng: 122.4194 });
  const [zoom, setZoom] = useState(6);
  //const [clickedLatLng, setClickedLatLng] = useState(null)
  const [infoOpen, setInfoOpen] = useState(false);

  const { isLoaded } = useLoadScript({
    // Enter your own Google Maps API key
    googleMapsApiKey: "AIzaSyCpivuPCu-jAq3DzWTQFu8o8TcBac0Dm0k",
    libraries: libraries,
  });

  const fitBounds = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    if (displayLocation) {
      bounds.extend(displayLocation.pos);
    } else {
      bounds.extend(defaultPlace.pos);
    }

    map.fitBounds(bounds);
  };

  const defaultPlace = {
    id: "default",
    pos: {
      lat: 37.7749,
      lng: -122.4194,
    },
  };

  // We have to create a mapping of our places to actual Marker objects
  const markerLoadHandler = (marker, place) => {
    return setMarkerMap((prevState) => {
      return { ...prevState, [place.id]: marker };
    });
  };

  const loadHandler = (map) => {
    // Store a reference to the google map instance in state
    map.setOptions({
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.RIGHT_TOP,
      },
    });
    setMapRef(map);
    // Fit map bounds to contain all markers
    fitBounds(map);
  };
  const setMapBounds = (e, pos) => {
    e.preventDefault();
    let searchBounds = new window.google.maps.LatLngBounds(),
      latlng = new window.google.maps.LatLng(pos.lat, pos.lng);
    searchBounds.extend(latlng);
    mapRef.setCenter(searchBounds.getCenter());
  };
  const renderMap = () => {
    return (
      <>
        <GoogleMap
          // Do stuff on map initial laod
          onLoad={loadHandler}
          // Save the current center position in state
          center={center}
          zoom={zoom}
          mapContainerStyle={{
            height: "100%",
            width: "100%",
          }}
          options={mapOptions}
        >
          {!displayLocation && (
            <Marker
              position={defaultPlace.pos}
              onLoad={(marker) => markerLoadHandler(marker, defaultPlace)}
            ></Marker>
          )}
          {displayLocation && (
            <Marker
              position={displayLocation.pos}
              onLoad={(marker) => markerLoadHandler(marker, displayLocation)}
            ></Marker>
          )}
        </GoogleMap>
      </>
    );
  };
  return isLoaded ? (
    <div className={cx("locator-map", "h-full", "w-full")}>
      {isLoaded && displayLocation ? renderMap() : "Loading..."}
    </div>
  ) : (
    <></>
  );
};

export default LocatorMap;
